import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/common/search.png';
import _imports_1 from '@assets/images/common/search_user.png';
const _withScopeId = n => (_pushScopeId("data-v-06e7b5f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "search-info"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_0
}), /*#__PURE__*/_createElementVNode("span", {
  class: "word"
}, "请输入搜索关键词"), /*#__PURE__*/_createElementVNode("div", {
  class: "btn"
}, "搜索")], -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_1
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "登录", -1));
import { env } from "md-base-tools/env";
import MDRouter from "@/service/router";
import { goToLogin } from "@/utils/user";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { reactive } from 'vue';
export default {
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      userIcon: store.state.user.userIcon,
      userId: store.state.user.userId
    });
    const goSearch = () => {
      router.push('/search');
    };
    // 在微博内跳转至个人中心
    const goCenter = () => {
      if (state.userId) {
        MDRouter.goUserCenter();
      } else {
        goToLogin();
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['search-box', {
          'pad-r': !_unref(env).isWeibo()
        }]),
        onClick: _withModifiers(goSearch, ["stop"])
      }, [_hoisted_2, _unref(env).isWeibo() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "search-user-center",
        onClick: _withModifiers(goCenter, ["stop"])
      }, [_unref(state).userId ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "user-icon",
        src: _unref(state).userIcon
      }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_5, _hoisted_6], 64))], 8, _hoisted_3)) : _createCommentVNode("", true)], 10, _hoisted_1);
    };
  }
};